import React from "react";
import PropTypes from "prop-types";
import CurrencyDropdown from "../CurrencyDropdown/CurrencyDropdown";
import LanguagesDropdown from "../LanguagesDropdown/LanguagesDropdown";
import styles from "./FooterMenu.scss";
import { ArrowDropDownIcon } from "../../theme/assets";
import classnames from "classnames";
import { defineMessages, FormattedMessage } from "react-intl";
import constants from "../../utils/constants";

const msgs = defineMessages({
  promoCode: {
    id: "footer.menu.promo_code",
    description: "Placeholder for promotion code",
    defaultMessage: "Code/coupon?",
  },
});

function FooterMenu({
  showLanguage,
  showCurrency,
  locale,
  currency,
  locales,
  currencies,
  onLanguageChange,
  onCurrencyChange,
  promoCode,
  toggleBookingFormSummary,
}) {
  return (
    <div className={classnames("wbkv9-FooterMenu-menuContainer", styles.menuContainer)}>
      {(showCurrency || showLanguage) && (
        <div
          className={classnames(
            "wbkv9-FooterMenu-dropdownMenu",
            "row end-xs",
            "DropdownMenu",
            styles.dropdownMenu
          )}>
          {showLanguage && (
            <div className={classnames("wbkv9-FooterMenu-itemContainer", styles.itemContainer)}>
              <LanguagesDropdown
                value={locale}
                label={locale}
                languages={locales}
                onLanguageChange={language => onLanguageChange({ locale: language })}
                placement="top-end"
                CustomArrowDown={
                  <div className={classnames("wbkv9-FooterMenu-arrowDown", styles.arrowDown)}>
                    <ArrowDropDownIcon />
                  </div>
                }
              />
            </div>
          )}
          {showCurrency && (
            <div className={classnames("wbkv9-FooterMenu-itemContainer", styles.itemContainer)}>
              <CurrencyDropdown
                value={currency}
                label={currency}
                currencies={currencies}
                onCurrencyChange={chosenCurrency => onCurrencyChange({ currency: chosenCurrency })}
                placement="top-end"
                CustomArrowDown={
                  <div className={classnames("wbkv9-FooterMenu-arrowDown", styles.arrowDown)}>
                    <ArrowDropDownIcon />
                  </div>
                }
              />
            </div>
          )}
          {promoCode !== constants.SHOW_PROMO_CODE.HIDE && (
            <div
              className={classnames("wbkv9-FooterMenu-itemContainer", styles.itemContainer)}
              onClick={toggleBookingFormSummary}>
              <div className={classnames("wbkv9-FooterMenu-promoCode", styles.promoCode)}>
                <FormattedMessage {...msgs.promoCode} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

FooterMenu.propTypes = {
  showLanguage: PropTypes.bool,
  showCurrency: PropTypes.bool,
  locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  currency: PropTypes.string,
  locales: PropTypes.object,
  currencies: PropTypes.object,
  onLanguageChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  promoCode: PropTypes.string,
};

export default FooterMenu;
